import Translations from '@helpers/translations'
import { Button, SubmitButton } from '@components/ui/Button'
import { SubmitButtonProps } from '@components/ui/Button/SubmitButton'
import styles from './styles.module.scss'

export type AddToCartButtonProps = {
  active: boolean
  onAddToCart: SubmitButtonProps['onClick']
  onOutOfStock: () => void
  handle: string
  isSelectedProductOutOfStock: boolean
}

function AddToCartButton({
  active,
  onAddToCart,
  onOutOfStock,
  handle,
  isSelectedProductOutOfStock
}: AddToCartButtonProps) {
  return (
    <>
      <div
        id="AddToCartButton"
        className={`addToCartButton-container ${styles.AddToCartButton_container}`}
      >
        {isSelectedProductOutOfStock ? (
          <Button variant="secondary" fullWidth="always" onClick={onOutOfStock}>
            Notify me when back in stock
          </Button>
        ) : (
          <SubmitButton
            classes={`add-to-cart add-to-cart-${handle} ${styles.AddToCartButton}`}
            onClick={onAddToCart}
            disabled={!active}
            fullWidth="always"
          >
            {Translations.localise('product.filters.add-to-bag')}
          </SubmitButton>
        )}
      </div>
    </>
  )
}

export default AddToCartButton
